import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonService } from 'src/app/Service/Common.service';
import { groupBy } from 'lodash';
import { CommunicationService } from 'src/app/Service/communication/communication.service';

@Component({
  selector: 'app-message-cart',
  templateUrl: './message-cart.component.html',
  styleUrls: ['./message-cart.component.css']
})
export class MessageCartComponent implements OnInit {
  public projectId!: number;
  public groupId!: number;
  public memberId!: number;
  public messages!: any[];
  public filteredMessages: any[] = [];
  selectedMessages: any[] = [];
  cartDataSource: any[] = [];
  cartSelectedList: any = [];
  cartRequest = {};
  cartSelectedListCopy!: any[];
  createdByList: any[] = [];
  createdBy: string = '';
  authorizedByList: any[] = [];
  authorizedBy: string = '';
  statusList: any[] = [];
  status: string = '';

  constructor(
    public dialogRef: MatDialogRef<MessageCartComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public communicationService: CommunicationService,
    private commonService: CommonService
  ) { }

  ngOnInit() {
    this.projectId = this.commonService.getProjectId();
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.memberId = this.commonService.getLoggedInUserId();
    this.getMessageList();
  }

  closeDialog(data: any) {
    this.dialogRef.close(data);
  }

  async getMessageList() {
    let reqData: any = {
      "transType": "MyMessages",
      "projectId": this.projectId,
      "groupId": this.groupId,
      "memberId": this.memberId,
      "mailBoxType": 1,
      "isConfidential": null,
      "sentType": null,
      "sentFrom": null,
      "sentTo": null
    };
    this.messages = await this.communicationService.GetMessageList(reqData).toPromise();
    if (this.data != undefined && this.data.length > 0) {
      this.selectedMessages = this.data;
    }
    this.setCartValues();
    this.setAutocompleteValues();
    this.filterMessages();
  }

  setAutocompleteValues() {
    if (this.messages.length != 0) {
      let result = this.messages.map(x => x.from);
      let filteredResult = result.filter((n, i) => result.indexOf(n) === i);
      this.createdByList = filteredResult.map(x => {
        return { value: x, description: x }
      });
      let result2 = this.messages.map(x => x.to);
      let filteredResult2 = result2.filter((n, i) => result2.indexOf(n) === i);
      this.authorizedByList = filteredResult2.map(x => {
        return { value: x, description: x }
      });
      let result3 = this.messages.map(x => x.status);
      let filteredResult3 = result3.filter((n, i) => result3.indexOf(n) === i);
      this.statusList = filteredResult3.map(x => {
        return { value: x, description: x }
      });
    }
    else {
      this.createdByList = [];
      this.authorizedByList = [];
    }
  }

  changeCreatedBy(event: any) {
    this.createdBy = event.value != -2 ? event.value : '';
    this.filterMessages();
  }

  changeAuthorizedBy(event: any) {
    this.authorizedBy = event.value != -2 ? event.value : '';
    this.filterMessages();
  }

  changeStatusBy(event: any) {
    this.status = event.value != -2 ? event.value : '';
    this.filterMessages();
  }

  filterMessages() {
    if (this.createdBy != '') {
      if (this.authorizedBy != '') {
        this.filteredMessages = this.messages.filter(x => x.authorisedByName == this.authorizedBy && x.createdBy == this.createdBy);
      }
      else {
        this.filteredMessages = this.messages.filter(x => x.createdBy == this.createdBy);
      }
    }
    else if (this.authorizedBy != '') {
      if (this.createdBy != '') {
        this.filteredMessages = this.messages.filter(x => x.createdBy == this.createdBy && x.authorisedByName == this.authorizedBy);
      }
      else {
        this.filteredMessages = this.messages.filter(x => x.authorisedByName == this.authorizedBy);
      }
    }
    else if (this.status != '') {
      this.filteredMessages = this.filteredMessages.filter(x => x.status == this.status);
    }
    else {
      this.filteredMessages = this.messages;
    }
    this.setCartValues();
  }

  setCartValues() {
    this.cartDataSource = this.removeDuplicates(this.filteredMessages, this.selectedMessages, 'messageId');
    this.cartSelectedList = [];
    this.cartSelectedListCopy = [];
    this.selectedMessages.forEach(eachMsg => {
      let cartValue: any = this.getAsCartSelectedValue(eachMsg.messageNumber, eachMsg.messageSubject);
      this.cartSelectedList.push(cartValue);
      this.cartSelectedListCopy.push(cartValue);
    });
    this.setCartParams();
  }

  removeDuplicates(dataSource: any[], selectedArray: any[], key: string) {
    let filteredArray: any = [],
      grpdSelecetedArray = groupBy(selectedArray, key);

    dataSource.forEach((eachData: any) => {
      if (!(grpdSelecetedArray[eachData[key]] && grpdSelecetedArray[eachData[key]].length)) {
        filteredArray.push(eachData);
      }
    });
    return filteredArray;
  }

  getAsCartSelectedValue(value: string | number, text: string) {
    value = value.toString().trim();
    text = text.trim();
    let output = {
      value,
      text: value + ' - ' + text
    };
    return output;
  }

  setCartParams() {
    this.cartRequest = {
      'params': {
        'LockingType': 'P',
        'selectedCartItems': this.cartSelectedList,
      },
      'settings': {
        'mode': 'popup',
        'textField': 'messageSubject',
        'valueField': 'messageNumber',
        'cartLabel': 'Choose Items',
        'minimumSelectedItemCount': 0
      },
      'dataSource': this.cartDataSource,
    }
  }

  getSelectedCartItems(event: any[]) {
    this.closeDialog(event);
  }

}
